import {Competitor} from "./competitor";
import {RaceRegistration} from "./race-registration/race-registration";

export class ManageCompetitorRequest {
  constructor(public competitor: Competitor, public raceRegistration: RaceRegistration) {
  }

}
